import React, { useEffect, useState } from "react";
import {
  Card,
  Typography,
  Box,
  Avatar,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Switch,
  Paper,
  Button,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  DialogActions,
} from "@mui/material";
import { Email, Phone } from "@mui/icons-material";
import { styled } from "@mui/system";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BASE_URL } from "../../constants";
import { FILE_RULES, validateFile } from "../../utils/fileValidation";

const StyledTableContainer = styled(TableContainer)({
  margin: "20px auto",
  borderRadius: "10px",
  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
});

const StyledTableCell = styled(TableCell)({
  fontSize: "1rem",
  fontWeight: "500",
  padding: "16px 24px",
  color: "#495057",
  textAlign: "center",
});

const StyledHeaderCell = styled(StyledTableCell)({
  fontWeight: "700",
  backgroundColor: "#003566",
  color: "#fff",
  textAlign: "center",
  fontSize: "1.1rem",
});

const StyledTableRow = styled(TableRow)(({ index }) => ({
  backgroundColor: index % 2 ? "#eef7ff" : "#fff",
}));

const OrgUsersProfile = ({ selectedUser, setFetchUsers, fetchUsers }) => {
  const [user, setUser] = useState(selectedUser);
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  useEffect(() => {
    setUser(selectedUser);
  }, [selectedUser]);
  console.log(user);
  const handleUserPermissionChange = (domain, action) => {
    setUser((prevUser) => ({
      ...prevUser,
      permissions: {
        ...prevUser.permissions,
        [domain]: {
          ...prevUser.permissions[domain],
          [action]: !prevUser.permissions[domain][action],
        },
      },
    }));
  };

  const handleSavePermission = async (e) => {
    e.preventDefault();
    const { _id } = selectedUser;
    console.log(user);
    // return;
    try {
      setLoading(true);
      const response = await fetch(
        `${BASE_URL}api/org/update-user-premission/${_id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ permissions: user.permissions }),
        },
      );

      const data = await response.json();

      if (data.success) {
        console.log("Permission Updated successfully", data);
        setFetchUsers(!fetchUsers);
        toast.success(data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      } else {
        console.log("Error:", data.message);
        toast.error("Error: " + data.message, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Something went wrong! Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const [openForm, setOpenForm] = useState(false);
  const [userData, setUserData] = useState({});
  console.log(4444, userData);
  const handleFormOpen = () => {
    setOpenForm(true);
    setUserData({
      userId: selectedUser?._id,
      userName: selectedUser?.userName,
      // userPassword: "",
      // userConfirmPassword: "",
      userContact: selectedUser?.userContact,
      role: selectedUser?.role,
      isTechnician: selectedUser?.isTechnician,
      technicianHeader: selectedUser?.technicianHeader,
      techSignature: selectedUser?.techSignWebLink,
    });
  };
  const handleFormClose = () => {
    setOpenForm(false);
    setFormErrors({});
  };
  const handleInputChange = (e) => {
    setUserData({
      ...userData,
      [e.target.name]: e.target.value,
    });
  };
  // const handleSignFileChange = (e) => {
  //   setUserData({
  //     ...userData,
  //     techSignature: e.target.files[0],
  //   });
  // };
  const handleSignFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const result = await validateFile(file, FILE_RULES.signature);
    if (!result.valid) { alert(result.error); e.target.value = ""; return; }
    setUserData({ ...userData, techSignature: file });
  };
  const validateForm = () => {
    const errors = {};

    if (!userData.userContact) errors.userContact = "Phone is required";
    else if (!/^[6-9]\d{9}$/.test(userData.userContact))
      errors.userContact = "Phone is invalid";
    if (!userData.userName) errors.userName = "Name is required";
    if (!userData.role) errors.role = "Please select a role";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    console.log(userData);
    const formData = new FormData();
    for (const key in userData) {
      formData.append(key, userData[key]);
    }
    // return;
    if (validateForm()) {
      setLoading(true);
      try {
        const response = await fetch(`${BASE_URL}api/org/update-user`, {
          method: "POST",
          headers: {},
          body: formData,
        });

        const data = await response.json();

        if (data.success) {
          console.log("Registration successful", data);
          alert(data.message);
          handleFormClose();
          setFetchUsers(!fetchUsers);
        } else {
          console.log("Error:", data.message);
          alert("Error: " + data.message);
        }
      } catch (error) {
        console.error("Error:", error);
        alert("Something went wrong! Please try again.");
      } finally {
        setLoading(false);
      }
    }
  };

  if (!user) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "#f0f4f8",
          color: "#1976d2",
          textAlign: "center",
        }}
      >
        <Typography
          variant="h4"
          fontWeight="bold"
          sx={{
            padding: 3,
            borderRadius: 2,
            backgroundColor: "#ffffff",
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
            letterSpacing: "0.5px",
            color: "#2a3e52",
          }}
        >
          Welcome to the Dashboard
        </Typography>
      </Box>
    );
  }

  return (
    <>
      <ToastContainer />
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#f0f4f8",
          padding: 2,
          alignItems: "flex-start",
        }}
      >
        <Card
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            borderRadius: 2,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
            backgroundColor: "#ffffff",
            padding: 2,
          }}
        >
          <Avatar
            sx={{
              width: 80,
              height: 80,
              backgroundColor: "#197278",
              fontSize: "2rem",
              marginRight: 2,
            }}
          >
            {user?.userName[0]}
          </Avatar>

          <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Typography
                variant="h5"
                fontWeight="bold"
                color="text.primary"
                gutterBottom
              >
                {user?.userName}
              </Typography>
              <Box sx={{ ml: 2 }}>
                <img src={user?.techSignWebLink} width={55} height={55} />
              </Box>
            </Box>
            <Divider sx={{ my: 1 }} />
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Phone sx={{ color: "#40916c", mr: 1 }} />
                <Typography variant="body2" color="text.secondary">
                  {user?.userContact}
                </Typography>
              </Box>
              <Button onClick={handleFormOpen}>Edit Profile</Button>
            </Box>
          </Box>
        </Card>
      </Box>

      <Dialog open={openForm} onClose={handleFormClose}>
        <DialogTitle>Edit User Profile</DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                autoFocus
                name="userName"
                label="User Name"
                type="text"
                size="small"
                fullWidth
                variant="filled"
                value={userData.userName}
                onChange={handleInputChange}
                error={!!formErrors.userName}
                helperText={formErrors.userName}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="userContact"
                label="User Phone"
                type="text"
                fullWidth
                size="small"
                variant="filled"
                value={userData.userContact}
                onChange={handleInputChange}
                error={!!formErrors.userContact}
                helperText={formErrors.userContact}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth variant="filled">
                <InputLabel id="demo-simple-select-filled-label">
                  Role
                </InputLabel>
                <Select
                  fullWidth
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={userData.role}
                  name="role"
                  size="small"
                  onChange={handleInputChange}
                  error={!!formErrors.role}
                  helperText={formErrors.role}
                >
                  <MenuItem value="Admin">Admin</MenuItem>
                  <MenuItem value="Front Office">Front Office</MenuItem>
                  <MenuItem value="Lab">Lab</MenuItem>
                  <MenuItem value="Finance">Finance</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth variant="filled">
                <InputLabel id="demo-simple-select-filled-label">
                  Is Technician?
                </InputLabel>
                <Select
                  fullWidth
                  labelId="demo-simple-select-filled-label"
                  id="demo-simple-select-filled"
                  value={userData.isTechnician}
                  name="isTechnician"
                  size="small"
                  onChange={handleInputChange}
                  // error={!!formErrors.isTechnician}
                  // helperText={formErrors.isTechnician}
                >
                  <MenuItem value={true}>Yes</MenuItem>
                  <MenuItem value={false}>No</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                name="technicianHeader"
                label="Technician Header"
                type="text"
                fullWidth
                size="small"
                variant="filled"
                multiline
                maxRows={4}
                value={userData.technicianHeader}
                onChange={handleInputChange}
                // error={!!formErrors.userContact}
                // helperText={formErrors.userContact}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl variant="filled" fullWidth>
                <Typography
                  sx={{
                    position: "absolute",
                    fontSize: "12px",
                    padding: "5px",
                  }}
                >
                  Change Signature
                </Typography>
                <TextField
                  type="file"
                  fullWidth
                  variant="filled"
                  name="techSignature"
                  onChange={handleSignFileChange}
                  inputProps={{ accept: "image/*" }}
                />
              </FormControl>
            </Grid>
          </Grid>
        </DialogContent>
        {!loading ? (
          <DialogActions>
            <Button onClick={handleFormClose} color="secondary">
              Cancel
            </Button>
            <Button onClick={handleFormSubmit} color="primary">
              Submit
            </Button>
          </DialogActions>
        ) : (
          <DialogActions sx={{ justifyContent: "center", padding: 2 }}>
            <CircularProgress size={24} />
          </DialogActions>
        )}
      </Dialog>

      <Box
        sx={{
          display: "flex",
          minHeight: "calc(100vh - 64px)",
          backgroundColor: "#f0f4f8",
          padding: 2,
          alignItems: "flex-start",
        }}
      >
        <StyledTableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <StyledHeaderCell>Domain</StyledHeaderCell>
                <StyledHeaderCell>Create</StyledHeaderCell>
                <StyledHeaderCell>Edit</StyledHeaderCell>
                <StyledHeaderCell>Delete</StyledHeaderCell>
                <StyledHeaderCell>View</StyledHeaderCell>
                <StyledHeaderCell>Restrict Upload</StyledHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Object.keys(user.permissions).map((domain, index) => {
                const isUploadRestrictedDomain = [
                  "pathologyManagement",
                  "radiologyManagement",
                  "microbiologyManagement",
                ].includes(domain);

                return (
                  <StyledTableRow key={index} index={index}>
                    <StyledTableCell>
                      {domain.split("M").join(" M").toUpperCase()}
                    </StyledTableCell>

                    {["create", "edit", "delete", "view", "restrictUpload"].map(
                      (action) => {
                        // ❌ Skip restrictUpload for other domains
                        if (
                          action === "restrictUpload" &&
                          !isUploadRestrictedDomain
                        ) {
                          return null;
                        }

                        return (
                          <StyledTableCell align="center" key={action}>
                            <Switch
                              color="secondary"
                              checked={user.permissions[domain][action]}
                              onChange={() =>
                                handleUserPermissionChange(domain, action)
                              }
                            />
                          </StyledTableCell>
                        );
                      },
                    )}
                  </StyledTableRow>
                );
              })}
            </TableBody>
          </Table>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              padding: "16px",
            }}
          >
            <Button
              onClick={handleSavePermission}
              disabled={loading}
              sx={{
                backgroundColor: loading ? "#cfcfcf" : "#4CAF50",
                color: "#fff",
                fontWeight: "bold",
                "&:hover": {
                  backgroundColor: loading ? "#cfcfcf" : "#388E3C",
                },
                padding: "8px 16px",
                borderRadius: "8px",
                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.2)",
                display: "flex",
                alignItems: "center",
              }}
            >
              {loading ? (
                <>
                  <CircularProgress
                    size={20}
                    sx={{ color: "#fff", marginRight: 1 }}
                  />{" "}
                  Saving...
                </>
              ) : (
                "SAVE Permissions"
              )}
            </Button>
          </Box>
        </StyledTableContainer>
      </Box>
    </>
  );
};

export default OrgUsersProfile;
